'use client'

import { centsToPriceInput } from '@mentora/app-shared/price-input'
import { Input, Label, Textarea } from '@mentora/ui-components'
import { useFormatter, useTranslations } from 'next-intl'

// The two fields every admin refund/cancel dialog asks for: an amount in the
// currency the buyer was charged in, and the reason the audit keeps.

export function AmountField({ id, value, onChange, maxCents, currency }: {
  id: string
  value: string
  onChange: (value: string) => void
  maxCents: number
  currency: string
}) {
  const t = useTranslations('transactions.actions')
  const format = useFormatter()
  const max = format.number(maxCents / 100, { style: 'currency', currency: currency.toUpperCase() })
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{t('amountLabel', { currency: currency.toUpperCase() })}</Label>
      <Input
        id={id}
        inputMode="decimal"
        autoComplete="off"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={centsToPriceInput(maxCents)}
      />
      <p className="text-xs text-muted-foreground">{t('amountHint', { max })}</p>
    </div>
  )
}

export function ReasonField({ id, value, onChange }: { id: string, value: string, onChange: (value: string) => void }) {
  const t = useTranslations('transactions.actions')
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{t('reasonLabel')}</Label>
      <Textarea
        id={id}
        value={value}
        onChange={e => onChange(e.target.value)}
        maxLength={500}
        rows={3}
        placeholder={t('reasonPlaceholder')}
        required
      />
      <p className="text-xs text-muted-foreground">{t('reasonHint')}</p>
    </div>
  )
}
